export enum ForecastTrend {
  Up = 'up',
  Down = 'down',
  Lateral = 'lateral',
}
